import { AutenticationModuleRoutes, AutenticationPath } from 'app/autentication/routes';
import { ImpersonationApiActions } from 'app/autentication/store/impersonation.actions';
import { GlobalContext } from 'context';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useDispatchState from 'shared/hooks/useDispatchState';
import { isAlreadyShownToUser } from 'shared/utils/error-delivery';
import ImpersonationBannerStyled from './ImpersonationBanner.styled';

const ImpersonationBanner = (): ReactElement | null => {
  const [{ isImpersonating, impersonatingAs }, dispatchApp] = useDispatchState(GlobalContext);
  const navigateRoute = useNavigate();

  if (!isImpersonating) {
    return null;
  }

  const handleReturn = async (): Promise<void> => {
    try {
      await ImpersonationApiActions.stopImpersonation(dispatchApp);
    } catch (error) {
      if (!isAlreadyShownToUser(error)) {
        toast.error(
          'Tu sesión volvió a la normalidad, pero el menú podría no haberse actualizado. Si falta algún módulo, recargá la página.',
          { position: 'top-right', autoClose: 8000 },
        );
      }
    } finally {
      navigateRoute(AutenticationModuleRoutes.get(AutenticationPath.Home) as string);
    }
  };

  return (
    <ImpersonationBannerStyled.Bar>
      <span>
        Estás viendo el sistema como <strong>{impersonatingAs}</strong>
      </span>
      <ImpersonationBannerStyled.ReturnButton type="button" onClick={handleReturn}>
        Volver a mi cuenta
      </ImpersonationBannerStyled.ReturnButton>
    </ImpersonationBannerStyled.Bar>
  );
};

export default ImpersonationBanner;
